module.exports = __webpack_public_path__ + "static/media/pulse.c866137e.svg";